import { render, staticRenderFns } from "./CompositionLayout.vue?vue&type=template&id=07d9f04c&scoped=true&"
import script from "./CompositionLayout.vue?vue&type=script&lang=js&"
export * from "./CompositionLayout.vue?vue&type=script&lang=js&"
import style0 from "./CompositionLayout.vue?vue&type=style&index=0&id=07d9f04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d9f04c",
  null
  
)

export default component.exports